import { BoxProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const DefaultStyle = (): any => ({
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: 'SECONDARY_GREY',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'SECONDARY_GREY',
    zIndex: 10,
    backgroundColor: 'WHITE',
    padding: 16,
    justifyContent: 'space-between',
    position: 'relative',
  } as ViewStyle,
})

const styles = (_breakpoint: number): any => {
  //   const isMobile = breakpoint < 560
  //   const isExtraaSmall = breakpoint <= 320
  //   const isSmall = breakpoint <= 360
  return {
    maincontainer: {
      marginHorizontal: 16,
      overflow: 'auto',
      maxHeight: '80vh',
      position: 'relative',
      marginTop: 16,
      paddingBottom: 40,
    } as ViewStyle,
    scroll: { flexGrow: 1 } as ViewStyle,
    aligncenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      paddingBottom: 16,
    } as ViewStyle,
    bulkrefund: {
      ...DefaultStyle(),
    },
    container: {
      backgroundColor: 'WHITE',
      flex: 1,
    } as BoxProps,
    containerWeb: {
      shadowOffset: { width: 1, height: 1 },
      shadowRadius: 3,
      shadowColor: 'GRAY_BORDER',
      borderRadius: 8,
      borderWidth: 1,
      borderColor: 'GRAY_BORDER',
      zIndex: 10,
      paddingHorizontal: 16,
      paddingBottom: 16,
      backgroundColor: 'WHITE',
      marginHorizontal: 16,
      paddingVertical: 16,
      flex: 1,
      overflowY: 'auto',
      nativeID: 'showListScrollBar',
    } as unknown as BoxProps,
    tabbarweb: {
      backgroundColor: 'WHITE',
      marginTop: 20,
      marginRight: 'auto',
      height: 36,
    } as BoxProps,
    downloadSampfile: {
      width: 180,
      height: 30,
      backgroundColor: 'WHITE',
      underlayColor: 'GRAY_SHADOW',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      shadowRadius: 2,
      shadowColor: 'GRAY_SHADOW',
    } as BoxProps,
    emptyContainer: {
      alignContent: 'center',
      flex: 1,
    } as ViewStyle,
    tableContainer: (_loadingState: boolean) =>
      ({
        alignContent: 'center',
        flexGrow: 1,
      } as ViewStyle),
  }
}

export default styles
